import React, { FC } from 'react';
import { Dropdown, Space } from 'antd';
import { truncateFullName } from '../../utils/accessory';
import { useLogout } from '@refinedev/core';
import styles from './userDropdown.module.scss';
import Triangle from '../ui/icons/triangle';
import { useTranslation } from 'react-i18next';

type UserDropdownProps = {
    name: string;
};

export const UserDropdown: FC<UserDropdownProps> = ({ name }) => {
    const { mutate: logout } = useLogout();
    const { t } = useTranslation();

    const items = [
        {
            key: 'logout',
            label: t('buttons.logout'),
            onClick: () => logout(),
        },
    ];

    return (
        <Dropdown
            trigger={['click']}
            placement="bottomRight"
            menu={{ items, className: styles.menu }}
            overlayClassName={styles.overlay}
        >
            <a onClick={e => e.preventDefault()} className={styles.trigger}>
                <Space>
                    {truncateFullName(name)}
                    <div className={styles.indicator}>
                        <Triangle />
                    </div>
                </Space>
            </a>
        </Dropdown>
    );
};
